/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * The schema for a CredentialSchema.
 */
export interface CredentialSchema {
    /**
     * The [Multibase](https://www.w3.org/TR/cid/#multibase)-encoded sha2-256 [Multihash](https://www.w3.org/TR/cid/#multihash) value.
     *
     * See [Resource Integrity](https://www.w3.org/TR/vc-data-integrity/#resource-integrity).
     */
    digestMultibase: string;
    schema: Truvity.ClaimsSchemaOptional;
}
